interface ApiErrorPayload {
	code?: string;
	message?: string;
}

interface ErrorWithResponse {
	response?: {
		data?: ApiErrorPayload;
	};
}

export function extractApiError(error: unknown): ApiErrorPayload | undefined {
	const axiosError = error as ErrorWithResponse;
	return axiosError?.response?.data;
}

export function getErrorCode(error: unknown): string | undefined {
	return extractApiError(error)?.code;
}
